import { z } from 'zod';
import { not } from './compute';
import { crewOrderSchema } from './schemas';

type CrewOrder = z.infer<typeof crewOrderSchema>;
type CrewOrderLineItem = CrewOrder['lineItems'][number];

export const hasEligibleReturnResolution = (item: CrewOrderLineItem) =>
  item.return.exchange.isEligible ||
  item.return.refund.isEligible ||
  item.return.giftCard.isEligible;

export const isItemReturnEligible =
  (areReturnsEnabled: boolean) => (item: CrewOrderLineItem) =>
    areReturnsEnabled &&
    !item.return.isFinalSale &&
    item.remainingReturnableQuantity > 0 &&
    hasEligibleReturnResolution(item);

export const isItemWarrantyEligible = (item: CrewOrderLineItem) =>
  item.warranty.isEligible && item.remainingReturnableQuantity > 0;

export const checkIfPastReturnWindow = (areReturnsEnabled: boolean) =>
  not(isItemReturnEligible(areReturnsEnabled));
